module.exports = __webpack_public_path__ + "assets/img/activity-time-a0aafd53.png";